<template>
  <message-template :direction="'outgoing'" :time="time" :channel="channel">
    <div class="LySlider">
      <div
        class="left-btn"
        v-if="contents.length > 1"
        @click="scrollLeft"
        :class="{'is-disabled': mostLeftPosition }"
      >
        <span class="ic-btn">
          <font-awesome-icon icon="caret-left"></font-awesome-icon>
        </span>
      </div>
      <div
        class="right-btn"
        v-if="contents.length > 1"
        @click="scrollRight"
        :class="{'is-disabled': mostRightPosition }"
      >
        <span class="ic-btn">
          <font-awesome-icon icon="caret-right"></font-awesome-icon>
        </span>
      </div>
      <div class="lyInner" ref="inner" v-on:scroll="calculateDisableScroll">
        <flex-bubble-layout
          v-for="(item, index) in contents"
          :data="item"
          :key="item.time + '-' + index"
          :uid="item.time + '-' + index"
        />
      </div>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from '../MessageTemplate.vue';
import FlexBubbleLayout from './FlexBubbleLayout.vue';

export default {
  name: 'FlexCarouselLayout',
  components: {
    'message-template': MessageTemplate,
    'flex-bubble-layout': FlexBubbleLayout,
  },
  props: {
    data: {
      type: Object,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mostLeftPosition: true,
      mostRightPosition: false,
    };
  },
  methods: {
    scrollLeft() {
      this.$refs.inner.scrollBy({
        left: -200,
        behavior: 'smooth',
      });
      this.calculateDisableScroll();
    },
    scrollRight() {
      this.$refs.inner.scrollBy({
        left: 200,
        behavior: 'smooth',
      });
      this.calculateDisableScroll();
    },
    calculateDisableScroll() {
      if (this.$refs.inner) {
        if (this.$refs.inner.scrollLeft === 0) {
          this.mostLeftPosition = true;
        } else {
          this.mostLeftPosition = false;
        }
        const currentPos = this.$refs.inner.scrollLeft + this.$refs.inner.offsetWidth;
        if (currentPos >= this.$refs.inner.scrollWidth) {
          this.mostRightPosition = true;
        } else {
          this.mostRightPosition = false;
        }
        // console.log(
        //   this.$refs.inner.offsetWidth,
        //   this.$refs.inner.scrollWidth,
        //   this.$refs.inner.scrollLeft
        // );
      }
      return false;
    },
  },
  computed: {
    contents() {
      if (this.data && this.data.template && this.data.template.contents) {
        return this.data.template.contents;
      }
      return [];
    },
  },
};
</script>
<style>
.left-btn,
.right-btn {
  background-color: rgba(51, 51, 51, 0.92);
  color: #fff;
  top: 48%;
  padding: 10px 15px;
  cursor: pointer;
  width: 20px;
  z-index: 100;
}
.left-btn.is-disabled,
.right-btn.is-disabled {
  background-color: rgba(185, 185, 185, 0.82);
  pointer-events: none;
}
.left-btn {
  position: absolute;
  left: 0;
  text-align: center;
}
.right-btn {
  position: absolute;
  right: 0;
  text-align: left;
}
@import '../../../styles/line-flex.css';
</style>
